import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var faqActionsEnum;
(function (faqActionsEnum) {
    faqActionsEnum["FAQ_REQUEST"] = "FAQ_REQUEST";
    faqActionsEnum["FAQ_SUCCESS"] = "FAQ_SUCCESS";
    faqActionsEnum["FAQ_ERROR"] = "FAQ_ERROR";
    faqActionsEnum["SELECT_FAQ"] = "SELECT_FAQ";
    faqActionsEnum["SUBMIT_FEEDBACK"] = "SUBMIT_FEEDBACK";
})(faqActionsEnum || (faqActionsEnum = {}));
export function fetchFaq(id) {
    return (dispatch) => {
        dispatch({ type: faqActionsEnum.FAQ_REQUEST });
        return ApiCaller.get(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/1/self-serve/helpcenter/faq`,
            action: faqActionsEnum.FAQ_REQUEST
        }, { query: { faqId: id } })).then(data => {
            if (data.RESPONSE) {
                dispatch({ type: faqActionsEnum.FAQ_SUCCESS, data: data.RESPONSE });
            }
            else {
                dispatch({
                    type: faqActionsEnum.FAQ_ERROR,
                    error: {}
                });
            }
        }, error => {
            dispatch({ type: faqActionsEnum.FAQ_ERROR, error });
        });
    };
}
export function submitFeedback(payload) {
    return () => {
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: '/api/1/self-serve/helpcenter/feedback/save',
            action: faqActionsEnum.SUBMIT_FEEDBACK
        }), payload);
    };
}
export function selectFaq(id, title) {
    return { type: faqActionsEnum.SELECT_FAQ, id, title };
}
